import { MapPin } from "lucide-react";

const neighborhoods = [
  "Pittsburgh (15210)",
  "Mt. Lebanon",
  "Squirrel Hill",
  "South Side",
  "Brookline",
  "Beechview",
  "Bethel Park",
  "Dormont",
  "Carrick",
  "Baldwin",
  "Mt. Oliver",
  "Overbrook",
  "Bloomfield",
  "Lawrenceville",
  "Shadyside",
  "East Liberty",
  "Greenfield",
  "Point Breeze",
  "Regent Square",
  "Swissvale",
  "Whitehall",
  "West Mifflin",
  "Munhall",
  "Homestead",
];

const ServiceArea = () => {
  return (
    <section id="service-area" className="border-b border-zinc-900 bg-[#F4F4F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D9480F] font-bold mb-4">
              [ 07 ] — Coverage Map
            </p>
            <h2 className="font-display uppercase font-semibold leading-[0.9] tracking-tighter text-4xl md:text-5xl mb-5">
              Serving Greater <br />
              <span className="text-[#0B2B40]">Pittsburgh.</span>
            </h2>
            <p className="text-zinc-700 leading-relaxed mb-6">
              Based in Carrick (15210), we service homes, parks and schools
              across Allegheny County. Don't see your neighborhood? Call anyway —
              we probably still got a guy.
            </p>
            <a
              href="tel:4847643392"
              className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] font-bold text-[#D9480F] hover:gap-3 transition-all"
            >
              Check coverage · 484-764-3392 →
            </a>
          </div>

          <div className="md:col-span-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {neighborhoods.map((n) => (
                <div
                  key={n}
                  className="bg-white border-2 border-black px-3 py-2.5 flex items-center gap-2 text-sm hover:bg-[#F59E0B]/20 transition-colors"
                >
                  <MapPin
                    className="w-3.5 h-3.5 text-[#D9480F] flex-shrink-0"
                    strokeWidth={2.5}
                  />
                  <span className="truncate font-medium">{n}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
